package kz.dentalcrm.app.screens.reply_by_template

import io.ktor.http.encodeURLQueryComponent
import kotlinx.collections.immutable.toPersistentList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.stateHandle
import kz.dentalcrm.app.domain.QuickRepliesRepository
import kz.dentalcrm.app.screens.reply_by_template.mvi.ReplyByTemplateViewEvent
import kz.dentalcrm.app.screens.reply_by_template.mvi.ReplyByTemplateViewSideEffect
import kz.dentalcrm.app.screens.reply_by_template.mvi.ReplyByTemplateViewState
import org.koin.core.component.inject

class ReplyByTemplateViewModel : BaseStateViewModel<
        ReplyByTemplateViewEvent,
        ReplyByTemplateViewState,
        ReplyByTemplateViewSideEffect>() {

    private val quickRepliesRepository: QuickRepliesRepository by inject()

    override fun setInitialState() = ReplyByTemplateViewState()

    override fun handleEvents(event: ReplyByTemplateViewEvent) {
        when (event) {
            is ReplyByTemplateViewEvent.Init -> {
                setState { copy(phone = event.phone) }
                loadQuickReplies()
            }
            ReplyByTemplateViewEvent.Reload -> loadQuickReplies()
            is ReplyByTemplateViewEvent.SelectReply -> {
                setState { copy(replyMessageInput = event.reply.message ?: "") }
            }
            is ReplyByTemplateViewEvent.MessageChanged -> {
                setState { copy(replyMessageInput = event.value) }
            }
            ReplyByTemplateViewEvent.SendTelegram -> {
                val cleanPhone = viewState.value.phone.filter { it.isDigit() }
                setEffect { ReplyByTemplateViewSideEffect.OpenUrl("https://t.me/+$cleanPhone") }
            }
            ReplyByTemplateViewEvent.SendWhatsApp -> {
                val cleanPhone = viewState.value.phone.filter { it.isDigit() }
                val encodedMessage = viewState.value.replyMessageInput.encodeURLQueryComponent()
                setEffect { ReplyByTemplateViewSideEffect.OpenUrl("https://wa.me/$cleanPhone?text=$encodedMessage") }
            }
        }
    }

    private fun loadQuickReplies() {
        setState { copy(isLoading = true) }
        launch(Dispatchers.Default) {
            quickRepliesRepository.getQuickReplies(page = 1).stateHandle(
                onError = { _, _ -> setState { copy(isLoading = false) } },
                onFailure = { setState { copy(isLoading = false) } },
                onSuccess = { data ->
                    setState {
                        copy(
                            isLoading = false,
                            quickReplies = (data ?: emptyList()).toPersistentList()
                        )
                    }
                }
            )
        }
    }
}
